'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var VixButton = _interopDefault(require('../button'));
var VixButtonLine = _interopDefault(require('../button-line'));
var VixBackground = _interopDefault(require('../background'));
var VixActionSheet = _interopDefault(require('../action-sheet'));
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm.data && Object.keys(_vm.data).length !== 0 ? _c('vix-background', {
      staticClass: "bill-detail"
    }, [_c('img', {
      attrs: {
        "src": _vm.data.logo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bill-detail-status"
    }, [_c('span', [_vm._v(_vm._s(_vm.data.statusMsg))]), _vm._v(" "), _c('div', {
      staticClass: "bill-detail-divide"
    })]), _vm._v(" "), _c('div', {
      staticClass: "bill-detail-amount",
      domProps: {
        "innerHTML": _vm._s(_vm.amount)
      }
    }), _vm._v(" "), _c('ul', [_vm._l(_vm.data.detail, function (item, index) {
      return _c('li', {
        key: index,
        staticClass: "clearfix"
      }, [_vm._v(" " + _vm._s(item.label) + " "), item.texts && item.texts[0] ? _c('div', {
        staticClass: "text",
        style: {
          color: item.textColor
        }
      }, _vm._l(item.texts, function (text) {
        return _c('div', {
          key: text
        }, [_vm._v(_vm._s(text))]);
      }), 0) : _c('span', {
        directives: [{
          name: "tap",
          rawName: "v-tap"
        }],
        ref: "detailText",
        refInFor: true,
        class: _vm.collapsedTexts.indexOf(index) !== -1 ? 'bill-detail-collapse' : '',
        style: {
          color: item.textColor
        },
        on: {
          "click": function click($event) {
            _vm.collapsedTexts.splice(_vm.collapsedTexts.indexOf(index), 1);
          }
        }
      }, [_vm._v(" " + _vm._s(item.text) + " ")])]);
    }), _vm._v(" "), _vm.data.withdrawItem ? _c('li', {
      staticClass: "clearfix bill-detail-withdraw"
    }, [_vm._v(" " + _vm._s(_vm.data.withdrawItem.label) + " "), _c('span', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      on: {
        "click": _vm.onClickWithdrawItem
      }
    }, [_vm._v(_vm._s(_vm.data.withdrawItem.text))])]) : _vm._e(), _vm._v(" "), _vm.data.repayItem ? _c('li', {
      class: ['clearfix', {
        'bill-detail-repay-processing': _vm.data.repayItem.status === 2,
        'bill-detail-repay-fail': _vm.data.repayItem.status === 4
      }]
    }, [_vm._v(" " + _vm._s(_vm.data.repayItem.label) + " "), _c('div', {
      staticClass: "bill-detail-repay-progress"
    }, [_c('i', {
      staticClass: "icon-success-outline"
    }), _vm._v(" "), _c('div', {
      staticClass: "bill-detail-repay-line"
    }), _vm._v(" "), _c('i', {
      staticClass: "icon-success-outline"
    }), _vm._v(" "), _c('i', {
      staticClass: "icon-error-outline"
    })]), _vm._v(" "), _c('div', {
      staticClass: "bill-detail-repay"
    }, [_c('div', [_vm._v(_vm._s(_vm.data.repayItem.tradeResult))]), _vm._v(" "), _c('div', {
      staticClass: "bill-detail-repay-time"
    }, [_vm._v(" " + _vm._s(_vm.data.repayItem.tradeTime) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "bill-detail-repay-bottom-text"
    }, [_vm._v(" " + _vm._s(_vm.data.repayItem.repayResult) + " ")]), _vm._v(" "), _vm.data.repayItem.repayTime ? _c('div', {
      staticClass: "bill-detail-repay-time bill-detail-repay-bottom-time"
    }, [_vm._v(" " + _vm._s(_vm.data.repayItem.repayTime) + " ")]) : _vm._e()])]) : _vm._e()], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm.data.buttons && _vm.data.buttons.length ? _c('vix-button-line', [_c('vix-button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      attrs: {
        "text": _vm.data.buttons[0].text,
        "outline": ""
      },
      on: {
        "click": function click($event) {
          _vm.onClick(_vm.data.buttons[0].url);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm.data.withdrawItem ? _c('vix-action-sheet', {
      attrs: {
        "show": _vm.showWithdrawList,
        "options": _vm.withDrawListOptions
      },
      on: {
        "hide": function hide($event) {
          _vm.showWithdrawList = false;
        }
      }
    }) : _vm._e()], 2) : _vm._e();
  },
  staticRenderFns: [],
  name: 'bill-detail',
  props: {
    data: Object
  },
  components: {
    VixButton: VixButton,
    VixButtonLine: VixButtonLine,
    VixBackground: VixBackground,
    VixActionSheet: VixActionSheet
  },
  data: function data() {
    return {
      showWithdrawList: false,
      collapsedTexts: []
    };
  },
  computed: {
    withDrawListOptions: function withDrawListOptions() {
      var _this = this;

      var data = this.data;
      var item = data.withdrawItem;

      if (item && item.withdrawList) {
        var options = item.withdrawList.map(function (item) {
          return {
            text: item.label,
            onClick: function onClick() {
              _this.onClick(item.url);
            }
          };
        });
        options.push({
          text: '取消',
          onClick: function onClick() {
            _this.showWithdrawList = false;
          }
        });
        return options;
      }

      return [];
    },
    amount: function amount() {
      var arr = this.data.amount.split('.');
      return "\n            <span>".concat(arr[0] + (arr[1] ? '.' : ''), "</span>\n            <span>").concat(arr[1] || '', "</span>\n        ");
    }
  },
  created: function created() {
    this.watchData();
  },
  methods: {
    // 判断文案是否超过一行，超过一行则须收起
    watchData: function watchData() {
      var _this2 = this;

      this.$nextTick(function () {
        var texts = _this2.$refs.detailText;
        texts && texts.forEach(function (text, index) {
          text.offsetHeight > 20 && _this2.collapsedTexts.push(index);
        });
      });
    },
    // 点击多项退款交易
    // 若只有一项，直接跳转
    // 若有多项，则弹出 actionSheet
    onClickWithdrawItem: function onClickWithdrawItem() {
      var length = this.withDrawListOptions.length;

      if (length > 1) {
        this.showWithdrawList = true;
      } else if (length === 1) {
        this.withDrawListOptions[0].onClick();
      }
    },
    onClick: function onClick(url) {
      this.$emit('click', url);
    }
  },
  watch: {
    data: function data() {
      this.watchData();
    }
  }
});

exports.default = index;
